import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";
import { PoweredBy } from "./PoweredBy";

// Standard footer for the main/home experience: permanent access to the current
// approved legal documents + the discreet "Powered by MindWeavage" badge.
// Legal links use the existing versioned legal_documents records (no duplicate copy).
const LABELS = {
  beta_terms: "Beta Terms",
  privacy_notice: "Privacy Notice",
  contributor_terms: "Contributor Terms",
};
const ORDER = ["beta_terms", "privacy_notice", "contributor_terms"];

export function SiteFooter({ variant = "light", showLegal = true }) {
  const [docs, setDocs] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!showLegal) return;
    api("/legal/documents", { auth: false }).then((r) => {
      if (r.ok) setDocs(r.data.documents || []);
    });
  }, [showLegal]);

  const byType = Object.fromEntries(docs.map((d) => [d.doc_type, d]));
  const clean = (t) => (t || "").replace(/\s*\(DRAFT\)/, "");

  return (
    <footer className={`ww-footer ww-footer-${variant}`} data-testid="site-footer">
      <div className="ww-footer-inner">
        {showLegal ? (
          <nav className="ww-footer-legal" aria-label="Legal documents">
            {ORDER.filter((t) => byType[t]).map((t) => (
              <button key={t} className="ww-footer-link" data-testid={`footer-legal-${t}`}
                      onClick={() => setActive(byType[t])}>
                {LABELS[t]}
              </button>
            ))}
          </nav>
        ) : <span />}
        <PoweredBy variant={variant} className="ww-footer-brand" />
      </div>

      {active && (
        <div className="ww-legal-overlay" data-testid="legal-doc-overlay" onClick={() => setActive(null)}>
          <div className="ww-legal-doc" onClick={(e) => e.stopPropagation()} data-testid="legal-doc">
            <div className="ww-legal-doc-head">
              <h3>{clean(active.title)} <span>({active.version})</span></h3>
              <button className="ww-legal-close" data-testid="legal-doc-close"
                      aria-label="Close" onClick={() => setActive(null)}><X size={20} /></button>
            </div>
            <div className="ww-legal-doc-body" data-testid="legal-doc-body">{active.body}</div>
          </div>
        </div>
      )}
    </footer>
  );
}
